import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { SLICE_KEYS } from '../SliceKeys'
import { BasicInfoFieldsNames } from 'FormDefinitions/BasicInfoForm/BasicInfoFields'
import { SetFieldValueActionProps, FormStateModel, SetValidationErrorActionProps } from './FormSliceModel'
import { TFieldsObjectNames } from 'models/Form/FieldsModels'
import { ExtendedInfoFieldsNames } from 'FormDefinitions/ExtendedInfoForm/ExtendedInfoFields'
import { AddressInfoFieldsNames } from 'FormDefinitions/AddressInfoForm/AddressInfoFields'

export const initialFormState: FormStateModel = {
      [BasicInfoFieldsNames.FirstName]: {
            value: '',
            validationError: undefined,
            isFirstFill: true,
      },
      [BasicInfoFieldsNames.Surname]: {
            value: '',
            validationError: undefined,
            isFirstFill: true,
      }, 
      [BasicInfoFieldsNames.Email]: {
            value: '',
            validationError: undefined,
            isFirstFill: true,
      }, 
      [BasicInfoFieldsNames.ConfirmEmail]: {
            value: '',
            validationError: undefined,
            isFirstFill: true,
      }, 
      [BasicInfoFieldsNames.PhoneNumber]: {
            value: '',
            validationError: undefined,
            isFirstFill: true,
      }, 


      [ExtendedInfoFieldsNames.Pesel]: {
            value: '',
            validationError: undefined,
            isFirstFill: true,
      },
      [ExtendedInfoFieldsNames.PersonalId]: {
            value: '',
            validationError: undefined,
            isFirstFill: true,
      },
      [ExtendedInfoFieldsNames.PersonalIdRelease]: {
            value: '',
            validationError: undefined,
            isFirstFill: true,
      },



      [AddressInfoFieldsNames.PostalCode]: {
            value: '',
            validationError: undefined,
            isFirstFill: true,
      },
      [AddressInfoFieldsNames.City]: {
            value: '',
            validationError: undefined,
            isFirstFill: true,
      }, 
      [AddressInfoFieldsNames.Street]: {
            value: '',
            validationError: undefined,
            isFirstFill: true,
      }, 
      [AddressInfoFieldsNames.HouseNumber]: {
            value: '',
            validationError: undefined,
            isFirstFill: true,
      }, 
      [AddressInfoFieldsNames.ApartamentNumber]: {
            value: '',
            validationError: undefined,
            isFirstFill: true,
      }, 
}


export const formSlice = createSlice({
   name: SLICE_KEYS.FORM_SLICE,
   initialState: initialFormState,
   reducers: {
      setFieldValue: (state, action: PayloadAction<SetFieldValueActionProps>) => { 
            const { fieldName, newValue } = action.payload
            const objectToChange = state[fieldName]
            objectToChange.value = newValue

            state[fieldName] = objectToChange  
      },
      setFieldValidateError: (state, action: PayloadAction<SetValidationErrorActionProps>) => {
            const { fieldName, validationError } = action.payload
            const objectToChange = state[fieldName]
            objectToChange.validationError = validationError

            state[fieldName] = objectToChange  
      },
      setIsFieldFirstFill: (state, action: PayloadAction<TFieldsObjectNames>) => {
            const objectToChange = state[action.payload]
            objectToChange.isFirstFill = false

            state[action.payload] = objectToChange
      },
      clearFieldValidateError: (state, action: PayloadAction<TFieldsObjectNames>)  => {
            const objectToChange = state[action.payload]
            objectToChange.validationError = undefined

            state[action.payload] = objectToChange 
      }
   }  
 })
 
 // Action creators are generated for each case reducer function
 export const { setFieldValue, setFieldValidateError, setIsFieldFirstFill, clearFieldValidateError } = formSlice.actions
 
 export default formSlice.reducer